module.exports = __webpack_public_path__ + "images/touch-icon-ipad-retina.450b1b2e3a831e0bd00b2bb31c38da48.png";